import moment from 'moment';

import { utilsActions } from '../../Store/Reducers/UtilsReducer';
import { resValue } from '../Other/FindValues';

export const searchFormData = (e,searchData,dispatch) => {
  const {name, value, type} = e.target;
  dispatch(utilsActions.setSearchData({...searchData, [name]: name==="owened_start_date"? moment(value).format("yyyy-MM-DD"):resValue(type, value)}));
};
